export default "__VITE_ASSET__01450045__"